export class PendingLetterInfo {
    letterId: number;
    requestingMember: string;
    requestingCompany: string;
    recipientMember: string;
    recipientCompany: string;
    letterContent: string;
    lettersUsed: number;
    reasonForIntroduction: string;
    cycleEndTime: number;
    approverNotes: string;
    isClosed: boolean;
    status: string;
}